import { DropdownMenu } from '@fiverr-private/dropdown';

export default DropdownMenu;
